import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

/**
 * Whenever the route path or search params change:
 *   1. Snap the window back to the top (otherwise React Router preserves the
 *      previous scroll position, which makes deep links from cards feel jarring).
 *   2. Fire a privacy-safe pageview to /api/track/pageview so the admin
 *      analytics dashboard has session + path data to roll up.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    // Pageview tracking — fire-and-forget, never blocks render.
    let sid = localStorage.getItem("inairlie_sid");
    if (!sid) {
      sid = `s_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
      localStorage.setItem("inairlie_sid", sid);
    }
    api
      .post("/track/pageview", {
        session_id: sid,
        path: pathname + (search || ""),
        referrer: document.referrer || null,
      })
      .catch(() => {});
  }, [pathname, search]);

  return null;
}
